"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySeasonType = void 0;
/**
 * Enum representation of activity/season types. This list will grow as
 * organizations support all the types of program offerings for an org
 */
var ActivitySeasonType;
(function (ActivitySeasonType) {
    ActivitySeasonType["LegacyOrgSeason"] = "legacy_org_season";
    ActivitySeasonType["ClubSeason"] = "club_season";
})(ActivitySeasonType = exports.ActivitySeasonType || (exports.ActivitySeasonType = {}));
//# sourceMappingURL=season.js.map